import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SignUpSubmissionSuccess = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 8, mt: 4, textAlign: 'center' }}>
        <CheckCircle 
          sx={{ 
            fontSize: 80, 
            color: '#4CAF50',
            mb: 4 
          }} 
        />
        
        <Typography variant="h4" gutterBottom>
          Thank you for signing up!
        </Typography>
        
        <Typography variant="h6" sx={{ mb: 6, color: 'text.secondary' }}>
          Your account has been created and is pending approval. 
          You will receive a notification once your account is activated.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/login')}
          sx={{ 
            py: 1.5,
            px: 4,
            fontSize: '1.1rem',
            textTransform: 'uppercase'
          }}
        >
          GO TO LOGIN
        </Button>
      </Paper>
    </Container>
  );
};

export default SignUpSubmissionSuccess; 